// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2SAC2","alert":"SettungsInbox_alert__2z8lU"};